import { Button, Grid, TextField } from "@mui/material"
import { useEffect, useState } from "react"
import { hikoAlert } from "../../../utils/HikoAlert"
import { Controller } from "react-hook-form";
import { GPSCoordinatesDialog } from "./GPSCoordinatesDialog";
import { northpowerBounds } from "../../../constants/northpowerBounds";

export default function MarkerControl({latLng, address, onLatLngChange, onUseMyLocation, onBringPinToCenter, formObject, sx}) {
    const [lat, setLat] = useState(latLng.lat)
    const [lng, setLng] = useState(latLng.lng)
    const [displayGPSDialog, setDisplayGPSDialog] = useState(false)
    const { control, formState: { errors }, setValue, trigger } = formObject


    const handleLatChange = (event) => {
        // console.log('handleLatChange event.target.value', event.target.value)
        const newLat = event.target.value
        setLat(newLat)
        onLatLngChange({lat: newLat, lng: lng})
    }

    const handleLngChange = (event) => {
        // console.log('handleLngChange event.target.value', event.target.value)
        const newLng = event.target.value
        setLng(newLng)
        onLatLngChange({lat: lat, lng: newLng})
    }

    const handleUseAddress = (event, address) => {
        // const address = '23 Mount Pleasant Road, Whangarei'
        // const address = '339 Ody Road, Whangarei'
        // const address = 'Queen Street, Auckland'
        // const address = 'The Moon'

        const bounds = new window.google.maps.LatLngBounds(
            new window.google.maps.LatLng(northpowerBounds.south, northpowerBounds.west),
            new window.google.maps.LatLng(northpowerBounds.north, northpowerBounds.east)
        )

        // const envConfig = require(`../../../../config/config.${env}.json`);
        // const myVar = envConfig.googleMapsAPIKey
        var geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({
            address: address,
            bounds: bounds
        }, function(results, status) {
            if (status === window.google.maps.GeocoderStatus.OK) {
                // hikoAlert('Geocode worked!', address, 'success')
                const location = results[0].geometry.location
                onUseMyLocation({lat: location.lat(), lng: location.lng() }) 
            } else {
                hikoAlert('Geocode was not successful', status)
            }
        });
        // hikoAlert('Some Address Location', 'lat lng', 'success')

    }

    const handleUseMyLocation = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    onUseMyLocation({lat: position.coords.latitude*1, lng: position.coords.longitude*1})
                },
                () => {
                    hikoAlert('We could not find your location', 'Please change browser settings to allow access to your location')
                }
            );
        }
    }

    const handleUseGPSLocation = () => {
        console.log('handleUseGPSLocation')
        setDisplayGPSDialog(true)
    }

    const handleGotoGPSCoordinates = (latiude, longitude) => {
        console.log('handleGotoGPSCoordinates', latiude, longitude)
        setDisplayGPSDialog(false)
        onUseMyLocation({lat: latiude*1, lng: longitude*1})
    }

    const handleCloseGPSDialog = () => {
        setDisplayGPSDialog(false)
    }
    
    useEffect(() => {
        //
        // A parent set the lat and lng. We update our state but don't emit any event
        //
        // console.log('Marker control updating lat and lng in state')
        setValue('lat', latLng.lat)
        setValue('lng', latLng.lng)
        setLat(latLng.lat)
        setLng(latLng.lng)
        trigger(['lat', 'lng'])
    }, [latLng, setValue, trigger])

  return (
    <Grid container>
        <Grid item xs={12} md={6} sx={{my: 1}}>
            <Controller name='lat' control={control}
                defaultValue={lat}
                rules={{validate: (value) => { return value > northpowerBounds.south && value < northpowerBounds.north}}}
                render={({field}) => ( // { onChange, onBlur, value, name, ref }
                    <TextField
                        sx={{mx:2, my:1}}
                        label="Lat"
                        value={lat}
                        type="number"
                        onChange={(e) => { field.onChange(e.target.value); handleLatChange(e)}}
                        error={!!errors.lat}
                        helperText={errors.lat && 'Marker latitude is out of range'}
                        disabled
                    />
                )}
            />
            <Controller name='lng' control={control}
                defaultValue={lng}
                rules={{validate: (value) => { return value > northpowerBounds.west && value < northpowerBounds.east}}}
                render={({field}) => ( // { onChange, onBlur, value, name, ref }
                    <TextField
                        sx={{mx:2, my:1}}
                        label="Lng"
                        value={lng}
                        type="number"
                        onChange={(e) => { field.onChange(e.target.value); handleLngChange(e)}}
                        error={!!errors.lng}
                        helperText={errors.lng && 'Marker longitude is out of range'}
                        disabled
                    />
                )}
            />
        </Grid>

        <Grid item xs={12} md={6} sx={{display: 'flex', justifyContent: 'flex-end'}}>
            <Button variant="outlined" sx={{my:2.4, mx: 2}} onClick={handleUseMyLocation}>Goto My Location</Button>
            {
                address
                &&
                <Button variant="outlined" sx={{my:2.4, mx: 2}} onClick={e => handleUseAddress(e, address)}>Goto ICP Address</Button>
            }
            <Button variant="outlined" sx={{my:2.4, mx: 2}} onClick={handleUseGPSLocation}>Goto GPS Location</Button>
            <Button variant="text" sx={{my:2.4, mx: 2}} onClick={onBringPinToCenter}>Centre Marker</Button>

            <GPSCoordinatesDialog
                open={displayGPSDialog}
                onSave={handleGotoGPSCoordinates}
                onClose={handleCloseGPSDialog}
            />

        </Grid>
    </Grid>
  );
}

